import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { setDrawerOpen } from '../../store/global';
import { fetchImage } from '../../utils/img';
import { getAvatarBackgroundStyle, getItemPicAsset } from '../../utils/item';
import { renderIconBySlug } from '../../content/icons';

export const LinkCard = props => {
  const { linkId, deleteLink } = props;

  const link = useSelector(state => state.items[linkId]);
  const dispatch = useDispatch();
  const [avatar, setAvatar] = useState('');
  const [avatarIconSlug, setAvatarIconSlug] = useState(null);
  const [avatarBgColor, setAvatarBgColor] = useState(null);

  useEffect(() => {
    const avatarAsset = getItemPicAsset(link, 0);
    if (avatarAsset.url) {
      fetchImage(avatarAsset.url, setAvatar);
    } else {
      setAvatar('');
    }
    setAvatarIconSlug(avatarAsset.iconSlug);
    setAvatarBgColor(avatarAsset.bgColor ?? null);
  }, [link]);

  return (
    <div className='flex gap-05 items-center px-1 py-05 border-b border-primary border-opacity-50 flex-1'>
      {deleteLink && (
        <div
          className='cursor-pointer transition opacity-50 hover:opacity-100 text-secondary'
          onDoubleClick={e => {
            e.stopPropagation();
            deleteLink(linkId);
          }}
        >
          <FaTimes />
        </div>
      )}
      <div
        className='rounded-full shadow flex items-center justify-center w-2 h-2'
        style={{
          ...(avatarBgColor
            ? getAvatarBackgroundStyle(avatarBgColor)
            : { backgroundColor: 'rgba(var(--main), 0.5)' }),
        }}
      >
        {avatarIconSlug
          ? renderIconBySlug(avatarIconSlug, {
              size: 32,
              color: 'var(--contrast)',
            })
          : avatar && (
              <div
                className='w-full h-full rounded-full'
                style={{
                  backgroundImage: `url(${avatar})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                }}
              ></div>
            )}
      </div>
      <div
        className='text-condensed font-bold text-lg cursor-pointer'
        onClick={() => {
          dispatch(setDrawerOpen(linkId));
        }}
      >
        {link?.label}
      </div>
    </div>
  );
};
